import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import TicketServAreaService from "../../../../../services/ticketServiceArea.service";
import { TTicketServiceAreaForm } from "./TicketServiceAreaSchema";
import { useWatch } from "react-hook-form";

const translationPath = "chatBot.page.service.ticketServiceArea.";
const ticketServiceArea = new TicketServAreaService();

const TicketServiceAreaField = () => {
  const { id } = useParams();

  const { t } = useTranslation();

  const [serviceAreaOptions, setServiceAreaOptions] = useState<ISelectType[]>(
    [],
  );

  const { sendRequest: sendTicketServiceAreaRequest } = useFetch(
    ticketServiceArea.list,
  );

  const { control } = useFormContext<TTicketServiceAreaForm>();

  const ticketServiceWatch = useWatch({
    name: "ticketService",
    control,
  });

  const loadServiceAreaOptions = useCallback(async () => {
    const { data, success } = await sendTicketServiceAreaRequest(undefined);
    if (data && success) {
      const filteredData = data.filter(
        (d) => d.ticketService.id === ticketServiceWatch.id,
      );
      if (id) {
        setServiceAreaOptions(filteredData.filter((d) => d.id !== id));
      } else {
        setServiceAreaOptions(filteredData);
      }
    }
  }, [sendTicketServiceAreaRequest, id, ticketServiceWatch]);

  useEffect(() => {
    if (ticketServiceWatch) {
      loadServiceAreaOptions();
    }
  }, [ticketServiceWatch, loadServiceAreaOptions]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        getOptionLabel={(option) => {
          return option.name;
        }}
        size="small"
        label={t(translationPath + "ticket_service_area_parent")}
        name="ticketServiceArea"
        options={serviceAreaOptions}
        disable={!ticketServiceWatch}
      />
    </Grid>
  );
};

export default memo(TicketServiceAreaField);
